<script lang="ts"></script>

<div class="reptile-similar-products__header">
    <h2
        class={[
            'oc-headline-200',
            'reptile-similar-products__headline',
            'reptile-similar-products__headline--old-style',
        ]}
    >
        Ähnliche Artikel
    </h2>
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-similar-products {
        &__header {
            display: block;
            grid-column: 1/-1;
        }

        &__headline {
            $headline-padding-top: 52px;
            $headline-padding-bottom: 30px;

            width: 100%;
            margin: 0;
            padding: $headline-padding-top tokens.$oc-semantic-spacing-50 $headline-padding-bottom;

            text-align: left;

            background: tokens.$oc-semantic-color-background-canvas;

            &--old-style {
                font-family: OttoSansThin, OTTOSans, Arial, Helvetica, sans-serif !important;
                font-size: 1.625rem !important;
                line-height: 1.2308em !important;
            }
        }
    }
</style>
